
const noop = () => {}

export function ajaxPost(path, values, params) {
    const { onSuccess = noop, onError = noop, parseRespJson = true } = params;
    const r = new XMLHttpRequest()
    r.open('POST', path)
    r.setRequestHeader('content-type', 'application/json;charset=UTF-8')
    r.setRequestHeader('accept', 'application/json')
    r.onreadystatechange = () => {
        if (r.readyState !== 4) { return }
        console.log('ajaxPost : done : response : ', r.responseText)
        if (parseRespJson) {
            try {
                r.responseJSON = JSON.parse(r.responseText)
            } catch (e) {
                console.error('failed to parse response as JSON', r)
            }
        }
        if (r.status >= 400) {
            onError(r)
        } else {
            onSuccess(r)
        }
    }
    r.send( JSON.stringify(values) )
}
